// extracted by mini-css-extract-plugin
export default {"component":"ClientDepositDetailsRow_component__OPgHO","intentId":"ClientDepositDetailsRow_intentId__-VVWE","flex":"ClientDepositDetailsRow_flex__86gpe"};